import {Environment, LoggingConfig} from "./config";
import Rollbar from "rollbar"

export interface Logging {
  log(thingToLog: string | Error | object, level?: 'error' | 'info'): void
}

export class RollbarLogging implements Logging {

  private readonly rollbar: Rollbar;

  constructor(
    private readonly accessToken: string,
    private readonly environment: Environment
  ) {
    this.rollbar = new Rollbar({
      accessToken,
      captureUncaught: true,
      captureUnhandledRejections: true,
      environment
    });
  }

  log(thingToLog: string | Error | object, level = 'info'): void {
    switch(level) {
      case 'info':
        this.rollbar.debug(thingToLog, thingToLog['message']);
        break;
      case 'error':
        this.rollbar.error(thingToLog, thingToLog['message']);
    }
  }
}

export class StubLogging implements Logging {

  loggedThings: any[] = [];

  log(thingToLog: string | Error | object, level = 'info'): void {
    console.log(JSON.stringify(thingToLog));

    this.loggedThings.push(thingToLog)
  }
}

export function buildLogging(environment: Environment, config: LoggingConfig): Logging {
  switch (config.type) {
    case 'rollbar':
      return new RollbarLogging(config.accessToken, environment);

    case 'stub':
      return new StubLogging();
  }
}
